export default class PromoBanner extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-promo-banner', PromoBanner);
